import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

export const getSavedGroupPostQuery = gql`
  query SavedGroupPostQuery($groupPostId: String!) {
    SavedGroupPosts(where: { groupPost: { equals: $groupPostId } }) {
      docs {
        id
        groupPost {
          id
        }
      }
    }
  }
`

export interface SavedGroupPostQueryInput {
  groupPostId: string
}

export interface SavedGroupPostQueryOutput {
  SavedGroupPosts: {
    docs: {
      id: string
      totalDocs: number
      groupPost: {
        id: string
      }
    }
  }
}

export const useSavedGroupPostQuery = (
  options: QueryHookOptions<SavedGroupPostQueryOutput, SavedGroupPostQueryInput>
) =>
  usePersistedCacheQuery<SavedGroupPostQueryOutput, SavedGroupPostQueryInput>(
    getSavedGroupPostQuery,
    options
  )
